import { css, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  width: 100%;
  max-width: 1190px;
  padding: 31px 24px;
  margin: 0 auto;
  background: ${theme.backgrounds.backgroundFour};
`

export const header = css`
  font-weight: 700;
`

export const tabs = css`
  margin: 40px 0 24px;
`
